import {
  APPROVE_DISCOUNT_FAILURE,
  APPROVE_DISCOUNT_REQUEST,
  APPROVE_DISCOUNT_SUCCESS,
  CREATE_DISCOUNT_FAILURE,
  CREATE_DISCOUNT_REQUEST,
  CREATE_DISCOUNT_SUCCESS,
  DELETE_DISCOUNT_FAILURE,
  DELETE_DISCOUNT_REQUEST,
  DELETE_DISCOUNT_SUCCESS,
  FETCH_DISCOUNT_APPROVALS_FAILURE,
  FETCH_DISCOUNT_APPROVALS_REQUEST,
  FETCH_DISCOUNT_APPROVALS_SUCCESS,
  FETCH_DISCOUNT_COUPONS_FAILURE,
  FETCH_DISCOUNT_COUPONS_REQUEST,
  FETCH_DISCOUNT_COUPONS_SUCCESS,
  FETCH_DISCOUNT_FAILURE,
  FETCH_DISCOUNT_HISTORY_FAILURE,
  FETCH_DISCOUNT_HISTORY_REQUEST,
  FETCH_DISCOUNT_HISTORY_SUCCESS,
  FETCH_DISCOUNT_REQUEST,
  FETCH_DISCOUNT_SUCCESS,
  FETCH_DISCOUNTS_FAILURE,
  FETCH_DISCOUNTS_REQUEST,
  FETCH_DISCOUNTS_SUCCESS,
  GENERATE_DISCOUNT_COUPONS_FAILURE,
  GENERATE_DISCOUNT_COUPONS_REQUEST,
  GENERATE_DISCOUNT_COUPONS_SUCCESS,
  MARK_DISCOUNT_COUPONS_PRINTED_FAILURE,
  MARK_DISCOUNT_COUPONS_PRINTED_REQUEST,
  MARK_DISCOUNT_COUPONS_PRINTED_SUCCESS,
  MARK_DISCOUNT_COUPONS_USED_FAILURE,
  MARK_DISCOUNT_COUPONS_USED_REQUEST,
  MARK_DISCOUNT_COUPONS_USED_SUCCESS,
  REJECT_DISCOUNT_FAILURE,
  REJECT_DISCOUNT_REQUEST,
  REJECT_DISCOUNT_SUCCESS,
  RESET_DISCOUNT_FILTERS,
  SET_DISCOUNT_FILTERS,
  UPDATE_DISCOUNT_FAILURE,
  UPDATE_DISCOUNT_REQUEST,
  UPDATE_DISCOUNT_SUCCESS,
} from "constants/Discount";

export const fetchDiscountsRequest = (params) => ({
  type: FETCH_DISCOUNTS_REQUEST,
  payload: params,
});

export const fetchDiscountsSuccess = (data) => ({
  type: FETCH_DISCOUNTS_SUCCESS,
  payload: data,
});

export const fetchDiscountsFailure = (error) => ({
  type: FETCH_DISCOUNTS_FAILURE,
  payload: error,
});

export const fetchDiscountRequest = (id) => ({
  type: FETCH_DISCOUNT_REQUEST,
  payload: id,
});

export const fetchDiscountSuccess = (data) => ({
  type: FETCH_DISCOUNT_SUCCESS,
  payload: data,
});

export const fetchDiscountFailure = (error) => ({
  type: FETCH_DISCOUNT_FAILURE,
  payload: error,
});

export const createDiscountRequest = (data) => ({
  type: CREATE_DISCOUNT_REQUEST,
  payload: data,
});

export const createDiscountSuccess = (data) => ({
  type: CREATE_DISCOUNT_SUCCESS,
  payload: data,
});

export const createDiscountFailure = (error) => ({
  type: CREATE_DISCOUNT_FAILURE,
  payload: error,
});

export const updateDiscountRequest = (id, data) => ({
  type: UPDATE_DISCOUNT_REQUEST,
  payload: { id, data },
});

export const updateDiscountSuccess = (data) => ({
  type: UPDATE_DISCOUNT_SUCCESS,
  payload: data,
});

export const updateDiscountFailure = (error) => ({
  type: UPDATE_DISCOUNT_FAILURE,
  payload: error,
});

export const deleteDiscountRequest = (id) => ({
  type: DELETE_DISCOUNT_REQUEST,
  payload: id,
});

export const deleteDiscountSuccess = (id) => ({
  type: DELETE_DISCOUNT_SUCCESS,
  payload: id,
});

export const deleteDiscountFailure = (error) => ({
  type: DELETE_DISCOUNT_FAILURE,
  payload: error,
});

export const setDiscountFilters = (filters) => ({
  type: SET_DISCOUNT_FILTERS,
  payload: filters,
});

export const resetDiscountFilters = () => ({
  type: RESET_DISCOUNT_FILTERS,
});

export const fetchDiscountCouponsRequest = (id, params) => ({
  type: FETCH_DISCOUNT_COUPONS_REQUEST,
  payload: { id, params },
});

export const fetchDiscountCouponsSuccess = (id, coupons, meta = null) => ({
  type: FETCH_DISCOUNT_COUPONS_SUCCESS,
  payload: { id, coupons, meta },
});

export const fetchDiscountCouponsFailure = (error) => ({
  type: FETCH_DISCOUNT_COUPONS_FAILURE,
  payload: error,
});

export const generateDiscountCouponsRequest = (id, data) => ({
  type: GENERATE_DISCOUNT_COUPONS_REQUEST,
  payload: { id, data },
});

export const generateDiscountCouponsSuccess = (id, result) => ({
  type: GENERATE_DISCOUNT_COUPONS_SUCCESS,
  payload: { id, result },
});

export const generateDiscountCouponsFailure = (error) => ({
  type: GENERATE_DISCOUNT_COUPONS_FAILURE,
  payload: error,
});

export const markDiscountCouponsPrintedRequest = (id, couponIds) => ({
  type: MARK_DISCOUNT_COUPONS_PRINTED_REQUEST,
  payload: { id, couponIds },
});

export const markDiscountCouponsPrintedSuccess = (id) => ({
  type: MARK_DISCOUNT_COUPONS_PRINTED_SUCCESS,
  payload: { id },
});

export const markDiscountCouponsPrintedFailure = (error) => ({
  type: MARK_DISCOUNT_COUPONS_PRINTED_FAILURE,
  payload: error,
});

export const markDiscountCouponsUsedRequest = (id, couponId) => ({
  type: MARK_DISCOUNT_COUPONS_USED_REQUEST,
  payload: { id, couponId },
});

export const markDiscountCouponsUsedSuccess = (id) => ({
  type: MARK_DISCOUNT_COUPONS_USED_SUCCESS,
  payload: { id },
});

export const markDiscountCouponsUsedFailure = (error) => ({
  type: MARK_DISCOUNT_COUPONS_USED_FAILURE,
  payload: error,
});

export const fetchDiscountApprovalsRequest = (params) => ({
  type: FETCH_DISCOUNT_APPROVALS_REQUEST,
  payload: params,
});

export const fetchDiscountApprovalsSuccess = (data) => ({
  type: FETCH_DISCOUNT_APPROVALS_SUCCESS,
  payload: data,
});

export const fetchDiscountApprovalsFailure = (error) => ({
  type: FETCH_DISCOUNT_APPROVALS_FAILURE,
  payload: error,
});

export const fetchDiscountHistoryRequest = (id) => ({
  type: FETCH_DISCOUNT_HISTORY_REQUEST,
  payload: id,
});

export const fetchDiscountHistorySuccess = (id, items) => ({
  type: FETCH_DISCOUNT_HISTORY_SUCCESS,
  payload: { id, items },
});

export const fetchDiscountHistoryFailure = (error) => ({
  type: FETCH_DISCOUNT_HISTORY_FAILURE,
  payload: error,
});

export const approveDiscountRequest = (id, data = {}, params = null) => ({
  type: APPROVE_DISCOUNT_REQUEST,
  payload: { id, data, params },
});

export const approveDiscountSuccess = (data) => ({
  type: APPROVE_DISCOUNT_SUCCESS,
  payload: data,
});

export const approveDiscountFailure = (error) => ({
  type: APPROVE_DISCOUNT_FAILURE,
  payload: error,
});

export const rejectDiscountRequest = (id, data = {}, params = null) => ({
  type: REJECT_DISCOUNT_REQUEST,
  payload: { id, data, params },
});

export const rejectDiscountSuccess = (data) => ({
  type: REJECT_DISCOUNT_SUCCESS,
  payload: data,
});

export const rejectDiscountFailure = (error) => ({
  type: REJECT_DISCOUNT_FAILURE,
  payload: error,
});
